import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AlertService } from 'src/app/services/alert.service';


@Component({
  selector: 'app-satisfaction-survey',
  templateUrl: './satisfaction-survey.component.html',
  styleUrls: ['./satisfaction-survey.component.scss'],
})
export class SatisfactionSurveyComponent implements OnInit {

@Input() questions: any[];
@Input() title: string;

  constructor(private alertService:AlertService,private modalController:ModalController) { }

  ngOnInit() {
    
  }
  changeRange(e){}
   setU(type,i){
   this.questions[i].response=type
   }
  send(){
    let without_res=this.questions.find(item=>item.type=='boolean' && !item.response)
    if(without_res){
      this.alertService.toastCustom('Falta responder la pregunta '+without_res.id,'danger')
      return
    }
 
    this.modalController.dismiss(this.questions.map(item=>({id:item.id,response:item.response})))

  }
}
